import React, { useCallback, useState } from 'react'
import Text from 'core/elements/Text'
import Button from 'core/elements/button'
import useUpdateAction from 'core/hooks/useUpdateAction'
import { deleteFlavor } from './actions'
import { ErrorMessage } from 'core/components/validatedForm/ErrorMessage'
import Modal from 'core/elements/modal'

export default function DeleteFlavor({ rows: flavorItems, onClose }) {
  const [error, setError] = useState(null)
  const { update: deleteFn, updating: deletingFlavors } = useUpdateAction(deleteFlavor)

  const flavorNames = flavorItems?.map((flavor) => flavor?.name || flavor?.id).join(', ')

  const handleDelete = useCallback(async () => {
    setError(null)
    try {
      const results = await Promise.all(
        flavorItems?.map(async (flavor) => {
          try {
            const result = await deleteFn(flavor)
            return { success: true, ...result }
          } catch (error) {
            return {
              success: false,
              error,
            }
          }
        }),
      )

      const allSuccess = results?.every((result) => result?.success)

      if (allSuccess) {
        onClose(true)
      } else {
        setError({
          title: 'Error Deleting Flavor(s)',
          message: results
            ?.filter((r) => !r?.success)
            ?.map(
              (r) =>
                r?.error?.response?.data?.badRequest?.message ||
                r?.error?.response?.data?.message ||
                r?.error?.message ||
                'Something went wrong, please try again.',
            )
            ?.join(', '),
        })
      }
    } catch (err) {
      setError({
        title: 'Unexpected Error',
        message: err?.message || 'Something went wrong. Please try again.',
      })
    }
  }, [flavorItems, deleteFn, onClose])

  return (
    <Modal
      panel="dialog"
      title="Delete Flavor"
      onClose={onClose}
      open
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={deletingFlavors}>
            Cancel
          </Button>
          <Button onClick={handleDelete} loading={deletingFlavors}>
            Confirm
          </Button>
        </>
      }
    >
      <>
        <Text variant="body2">This will permanently delete the following flavor(s).</Text>
        <Text variant="body2">{flavorNames}</Text>
        {!!error && <ErrorMessage>{error.message}</ErrorMessage>}
      </>
    </Modal>
  )
}
